import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import styled from 'styled-components'
import Dropzone from 'react-dropzone'
import { RowRemoveButton } from '../common/components'
import { getImageName } from '../common/apis'
import i18n from 'live/services/i18n'
import LiveTooltip from 'live/components/ui/tooltip'

interface Props {
    setImageFile: Dispatch<SetStateAction<FileType>>
    currentProductImageId: string
}

export default function UploadButton({ setImageFile, currentProductImageId }: Props): JSX.Element {
    const [fileName, setFileName] = useState(undefined)
    useEffect(() => {
        if (currentProductImageId) {
            getImageName(currentProductImageId).then(imageName => {
                if (imageName) setFileName(imageName)
            })
        }
    }, [currentProductImageId])

    function handleImage(file?: FileType): void {
        if (file) {
            setFileName(file.name)
            setImageFile(file)
        } else {
            setFileName(undefined)
            setImageFile({ removeFile: true })
        }
    }

    return (
        <StyledUploadButton className="UploadButton">
            <Dropzone
                className="UploadButton--dropComponent"
                activeClassName="active2"
                key={'default'}
                activeStyle={{}}
                onDrop={file => handleImage(file[0])}
                data-cy="drag-and-drop"
            >
                <i className="far fa-file-upload"></i>
                <span className="UploadButton--dropComponent__fileName">
                    {fileName || i18n('Choose or drag a file')}{' '}
                </span>
            </Dropzone>
            <LiveTooltip position="top" content={i18n('Remove Image')} hide={!fileName}>
                <RowRemoveButton className="UploadButton--removeButton" onClick={() => handleImage()}>
                    <i className="far fa-trash-alt" />
                </RowRemoveButton>
            </LiveTooltip>
        </StyledUploadButton>
    )
}

const StyledUploadButton = styled.div`
    cursor: pointer;
    width: 100%;
    display: flex;
    margin-bottom: 25px;
    .UploadButton {
        &--dropComponent {
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-grow: 1;
            color: ${({ theme }) => theme['blue-500']};
            background-color: ${({ theme }) => theme['gray-0']};
            padding: 8px 0;
            margin-right: 10px;
            border: 2px solid ${({ theme }) => theme['blue-500']};
            border-radius: 3px;

            &__fileName {
                cursor: pointer;
                font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
                font-style: normal;
                font-weight: 600;
                font-size: 15px;
                line-height: 16px;
                margin-left: 6px;
                color: ${({ theme }) => theme['blue-500']};
                text-overflow: ellipsis;
            }
            &:hover {
                color: ${({ theme }) => theme['gray-0']};
                background-color: #128ce1;
                border-color: none;

                span {
                    color: ${({ theme }) => theme['gray-0']};
                }
            }
        }
        &--removeButton {
            border-radius: 3px;
            margin-left: 20px;
        }
    }

    .active2 {
        cursor: pointer;
        background-color: ${({ theme }) => theme['gray-300']};
    }
`
